<template>
    <v-card>
        <v-card-title>会員フォロー状況リスト</v-card-title>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex v-if="isSearch">
                    <v-btn class="primary mr-2" @click="openDialog">検索</v-btn>
                    <v-btn class="error mr-2" @click="resetSearch">検索リセット</v-btn>
                </v-flex>
                <v-flex v-else>
                    <v-btn @click="openDialog">検索</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="customers"
                :loading="loading"
                hide-default-footer
                :items-per-page="conditions.perPage"
                class="elevation-1"
            >
                <!-- Header -->
                <template v-slot:header.name>
                    <div @click="handleSort('name')" class="d-flex align-center cursor-pointer">
                        <div>
                            名前
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'name'">{{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
                        </div>
                    </div>
                </template>

                <template v-slot:header.last_history>
                    最終フォロー日<br>フォロー内容
                </template>

                <template v-slot:header.count_tel>
                    <div @click="handleSort('count_tel')" class="d-flex justify-center align-center cursor-pointer">
                        <div>
                            TEL回数
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'count_tel'">
                                {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                            </v-icon>
                        </div>
                    </div>
                </template>
                <template v-slot:header.count_in_house>
                    <div @click="handleSort('count_in_house')" class="d-flex justify-center align-center cursor-pointer">
                        <div>
                            見合回数
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'count_in_house'">
                                {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                            </v-icon>
                        </div>
                    </div>
                </template>
                <template v-slot:header.count_connect>
                    <div @click="handleSort('count_connect')" class="d-flex justify-center align-center cursor-pointer">
                        <div>
                            コネクト見合回数
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'count_connect'">
                                {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                            </v-icon>
                        </div>
                    </div>
                </template>
                <template v-slot:header.count_date_matching>
                    <div @click="handleSort('count_date_matching')" class="d-flex justify-center align-center cursor-pointer">
                        <div>
                            デート回数
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'count_date_matching'">
                                {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                            </v-icon>
                        </div>
                    </div>
                </template>
                <template v-slot:header.count_company_visit>
                    <div @click="handleSort('count_company_visit')" class="d-flex justify-center align-center cursor-pointer">
                        <div>
                            カウンセ回数
                        </div>
                        <div>
                            <v-icon v-if="sortBy === 'count_company_visit'">
                                {{ sortDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                            </v-icon>
                        </div>
                    </div>
                </template>

                <!-- Body -->
                <template v-slot:[`item.name`]="{ item }">
                    {{ item.name }}
                </template>
                <template v-slot:[`item.last_history`]="{ item }">
                    {{ showLastHistoryTargetDate(item.latest_target_date, item.kind, item.status) }} <br>
                    {{ showLastHistoryKind(item.kind, item.status) }}
                </template>
                <template v-slot:[`item.count_tel`]="{ item }">
                    {{ item.count_tel }}({{ item.count_tel_auto_answer }})
                </template>
                <template v-slot:[`item.count_in_house`]="{ item }">
                    {{ item.count_in_house }}
                </template>
                <template v-slot:[`item.count_connect`]="{ item }">
                    {{ item.count_connect }}
                </template>
                <template v-slot:[`item.count_date_matching`]="{ item }">
                    {{ item.count_date_matching }}
                </template>
                <template v-slot:[`item.count_company_visit`]="{ item }">
                    {{ item.count_company_visit }}
                </template>
                <template v-slot:[`item.shop_name`]="{ item }">
                    {{ showShopName(item.shop_id) }}
                </template>
                <template v-slot:[`item.course_name`]="{ item }">
                    {{ showCourse(item.course) }}
                </template>
                <template v-slot:[`item.target_shift_month`]="{ item }">
                    {{ showTargetShift(item.course) }}
                </template>
                <template v-slot:[`item.contract_date`]="{ item }">
                    {{ item.contract_date }}
                </template>
                <template v-slot:[`item.year`]="{ item }">
                    {{ item.year }}
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-btn fab small dark class="info mr-2" :to="`/customer/history/${item.id}`" target="_blank">
                        経緯表
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination
                v-model="currentPage"
                :length="total"
                @input="reloadList"
            ></v-pagination>
        </v-card-text>

        <v-layout row justify-center>
            <v-dialog v-model="searchDialog" persistent max-width="800px">
                <v-form>
                    <v-card>
                        <v-card-title>
                            <span class="headline">会員検索</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md3 v-if="canSearchAll()">
                                        <v-select
                                            v-model="conditions.shop_id"
                                            :items="searchShops"
                                            label="支店"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.counselor_id"
                                            :items="searchCounselors"
                                            label="担当CO"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.phone_number"
                                            label="電話番号"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.number"
                                            type="number"
                                            label="会員No."
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.name"
                                            label="名前"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.gender"
                                            :items="searchGenders"
                                            label="性別"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.status"
                                            :items="searchStatus"
                                            label="状態"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.alert"
                                            :items="searchAlert"
                                            label="アラート"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.perPage"
                                            :items="perPages"
                                            label="件数"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.course_id"
                                            :items="searchCourses"
                                            label="コース"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-dialog
                                            ref="dialog1"
                                            v-model="timePick['shift_target_month']"
                                            :return-value.sync="conditions.shift_target_month"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="conditions.shift_target_month"
                                                    label="シフト対象月"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-if="timePick['shift_target_month']"
                                                v-model="conditions.shift_target_month"
                                                full-width
                                                scrollable
                                                type="month"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="timePick['shift_target_month'] = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary" @click="saveTimeStart">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-checkbox
                                            v-model="conditions.is_exit"
                                            label="退会済会員"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="info"
                                @click="search"
                                >検索</v-btn
                            >
                            <v-btn @click="closeDialog">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"
import moment from "moment"

export default {
    title: "会員フォロー状況リスト",
    name: "customer_list",
    mixins: [utilDatetime],
    data: () => ({
        CUSTOMER: CUSTOMER,
        customers: [],
        courses: [],
        loading: true,
        headers: [
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "最終フォロー日/フォロー内容", value: "last_history", align: "start", sortable: false },
            { text: "TEL回数", value: "count_tel", align: "center", sortable: false },
            { text: "見合回数", value: "count_in_house", align: "center", sortable: false },
            { text: "コネクト見合回数", value: "count_connect", align: "center", sortable: false },
            { text: "デート回数", value: "count_date_matching", align: "center", sortable: false },
            { text: "カウンセ回数", value: "count_company_visit", align: "center", sortable: false },
            { text: "所属店舗", value: "shop_name", align: "start", sortable: false },
            { text: "コース", value: "course_name", align: "start", sortable: false },
            { text: "シフト対象月", value: "target_shift_month", align: "start", sortable: false },
            { text: "初入会日", value: "contract_date", align: "start", sortable: false },
            { text: "活動年数", value: "year", align: "start", sortable: false },
            { text: "操作", value: "action", align: "center", sortable: false },
        ],
        sortBy: '',
        sortDirect: 'DESC',
        currentPage: 1,
        perPage: 50,
        total: null,
        prefectures: [],
        shops: [],
        conditions: {
            shop_id: 0,
            counselor_id: 0,
            number: "",
            phone_number: "",
            name: "",
            gender: 0,
            status: 0,
            alert: 0,
            is_exit: false,
            perPage: 50,
            course_id: 0,
            shift_target_month: '',
        },
        searchDialog: false,
        searchShops: [],
        searchCounselors: [],
        searchGenders: [],
        searchCourses: [],
        searchStatus: [
            { value: 0, text: "全て" },
            { value: 1, text: "シフト対象者" },
            { value: 2, text: "退会予備状態" },
            { value: 3, text: "退会処理待ち" },
            { value: 4, text: "休止会員" },
        ],
        searchAlert: [
            { value: 0, text: "全て" },
            { value: 1, text: "稼働中のみ" },
            { value: 2, text: "停止中のみ" },
        ],
        perPages: [
            { value: 50, text: "50件" },
            { value: 100, text: "100件" },
            { value: 200, text: "200件" },
        ],
        deleteDialog: false,
        deleteTargetId: 0,
        moment,
        timePick: [],
        isSearch: false,
    }),
    mounted() {
        this.resetSearch();
        this.currentPage = parseInt(this.$route.query.page || 1);
    },
    async beforeRouteUpdate(to, from, next) {
        this.currentPage = parseInt(to.query.page || 1);
        await this.loadList();
        next();
    },
    methods: {
        async reloadList() {
            const url = `/following_status/list?page=${this.currentPage}`;
            this.$router.push(url);
            scrollTo(0, 0);
        },
        async loadList() {
            this.loading = true;
            try {
                const result = await this.$axios
                    .get("/api/v1/customer/following_status", {
                        params: {
                            page: this.currentPage,
                            perPage: this.conditions.perPage,
                            shop_id: this.conditions.shop_id,
                            counselor_id: this.conditions.counselor_id,
                            number: this.conditions.number,
                            phone_number: this.conditions.phone_number,
                            name: this.conditions.name,
                            gender: this.conditions.gender,
                            status: this.conditions.status,
                            alert: this.conditions.alert,
                            is_exit: this.conditions.is_exit,
                            sortBy: this.sortBy,
                            sortDesc: this.sortDesc,
                            course_id: this.conditions.course_id,
                            shift_target_month: this.conditions.shift_target_month,
                        }
                    })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((error) => {
                        return error;
                    });

                if (result) {
                    this.customers = result.customers;
                    this.total = result.total;
                    this.shops = result.shops;
                    this.prefectures = result.prefectures;
                    this.courses = result.courses;

                    this.searchShops = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.shops.forEach(shop => this.searchShops.push({ value: shop.id, text: shop.name}));
                    this.searchCounselors = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.counselors.forEach(c => this.searchCounselors.push(c));
                    this.searchCounselors.push({ value: -1, text: "未定" });
                    this.searchGenders = [{
                        value: 0,
                        text: "全て"
                    }];
                    CUSTOMER.GENDER.LIST.forEach(g => this.searchGenders.push(g));
                    this.searchCourses = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.courses.forEach(course => this.searchCourses.push({ value: course.id, text: course.name}));
                }
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },
        showShopName(shopId) {
            const shop = this.shops.find(shop => shop.id == shopId);
            if(!shop) return '';
            return shop.name;
        },
        showCourse(course) {
            if (!course) {
                return '';
            }
            
            if (course.is_expired) {
                return course.name;
            }
            return '期限切れ';
        },
        showTargetShift(course) {
            if (!course || !course.end_date) {
                return '';
            }
            return moment(course.end_date).format('yyyy年MM月');
        },
        showLastHistoryTargetDate(latest_target_date, kind, status) {
            // status = 3, 予定
            return kind && latest_target_date && status == 3 ? moment(latest_target_date).format('YYYY/MM/DD') : '';
        },
        showLastHistoryKind(kind, status) {
            // status = 3, 予定
            return kind && status == 3 ? CUSTOMER.EXEC_KIND.getName(kind) : '';
        },
        loadSearchConditions() {
            this.conditions = Object.assign({}, this.$store.state.followStatusConditions);
        },
        isSearching() {
            if(this.$store.state.followStatusConditions.shop_id != 0) return true;
            if(this.$store.state.followStatusConditions.counselor_id != 0) return true;
            if(this.$store.state.followStatusConditions.number && this.$store.state.followStatusConditions.number.length > 0) return true;
            if(this.$store.state.followStatusConditions.phone_number && this.$store.state.followStatusConditions.phone_number.length > 0) return true;
            if(this.$store.state.followStatusConditions.name && this.$store.state.followStatusConditions.name.length > 0) return true;
            if(this.$store.state.followStatusConditions.gender != 0) return true;
            if(this.$store.state.followStatusConditions.status != 0) return true;
            if(this.$store.state.followStatusConditions.alert != 0) return true;
            if(this.$store.state.followStatusConditions.is_exit) return true;
            if(this.$store.state.followStatusConditions.course_id != 0) return true;
            if(this.$store.state.followStatusConditions.shift_target_month != '') return true;
            return false;
        },
        async search() {
            this.closeDialog();
            if(this.currentPage != 1) {
                this.currentPage = 1;
                await this.reloadList();
            } else {
                await this.loadList();
            }
            this.$store.dispatch("setCustomerSearchFollowStatusConditions", this.conditions);
            this.isSearch = this.isSearching();
        },
        resetSearch() {
            this.conditions = {
                shop_id: 0,
                counselor_id: 0,
                number: "",
                phone_number: "",
                name: "",
                gender: 0,
                status: 0,
                alert: 0,
                is_exit: false,
                perPage: 50,
                course_id: 0,
                shift_target_month: '',
            };
            this.search();
        },
        openDialog() {
            this.loadSearchConditions();
            this.searchDialog = true;
        },
        closeDialog() {
            this.searchDialog = false;
        },
        canSearchAll() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_ALL) return true;
            return false;
        },
        async handleSort(field) {
            if (this.sortBy === field) {
                this.sortDesc = !this.sortDesc;
            } else {
                this.sortBy = field;
                this.sortDesc = false;
            }
            await this.loadList();
        },
        saveTimeStart() {
            this.$refs.dialog1.save(this.conditions.shift_target_month)
        },
    },
};
</script>
<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
